import { BaseFieldView } from '../BaseField/views';

export const CheckboxFieldView = BaseFieldView.extend({
    events: {
        'change input[type=checkbox]': 'save_value'
    },

    save_value: function (event) {
        var checkbox = this.$el.find('.checkbox_mod');
        this.model.set({ value: checkbox.is(':checked') });

        // Change UI for our fake checkbox button
        var fake_checkbox = this.$el.find('.fake_checkbox');
        if (checkbox.is(':checked')) {
            fake_checkbox.addClass('checked');
        } else {
            fake_checkbox.removeClass('checked');
        }

        return false;
    },

    on_change_action: function () {
        this._scroll_down_one_field();
    }
});
